<!--
 * @Description: 绑定角色
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-12 13:57:10
-->
<template>
  <div class="info">
    <s-help :text="$t('binding_help_tip')" class="help" v-if="widthHelp"/>
    <div class="info-title">{{ title }}</div>
    <img src="@/static/assets/ui/pc/logo.png" class="img-logo">
    <div class="info-body">
      <slot/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoPopBase',
  props: {
    title: {
      type: String,
      default: ''
    },
    widthHelp: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="less" scoped>
  .info {
    position: relative;
    width: 570px;
    background: rgba(255, 255, 255,.85);
    text-align: center;
    padding: 35px 0;
    margin-top: 125px;
    .img-logo {
      margin-top: 8px;
    }
    .info-body {
      padding: 0 54px;
    }
    .help {
      position: absolute;
      top: 26px;
      right: 24px;
    }
  }
  @media screen and (max-width: 750px) {
    .info {
      width: 85.8667rem;
      padding: 4rem 0;
      margin-top: 8.8rem;
      .img-logo {
        width: 48.8rem;
        margin-top: 1.0667rem;
      }
      .info-body {
        padding: 0 7.7333rem;
      }
      .help {
        top: 3.4667rem;
        right: 3.2rem;
      }
    }
  }
</style>
